package com.upcominds.expedite.dto

import kotlinx.serialization.Serializable

@Serializable
data class CommunityEnergyConnectionRequest(val buildingName: String? = null)

@Serializable
data class DailyEnergyReadingDTO(val periodStart: String, val periodEnd: String, val consumptionKwh: Double)

@Serializable
data class DailyBuildingReadingDTO(val periodStart: String, val periodEnd: String, val value: Double)

@Serializable
data class BuildingMetricDTO(
    val id: String,
    val label: String,
    val unit: String,
    val summaryType: String,
    val readings: List<DailyBuildingReadingDTO> = emptyList()
)

@Serializable
data class CommunityEnergyDTO(
    val communityId: String,
    val buildingName: String? = null,
    val source: String = "Fusion API",
    val metric: String = "electricity_consumption_kwh",
    val unit: String = "kWh",
    val aggregation: String = "1d",
    val requestedDays: Int = 30,
    val lastAttemptAt: String? = null,
    val lastSyncAt: String? = null,
    val lastError: String? = null,
    val latestReading: DailyEnergyReadingDTO? = null,
    val totalConsumptionKwh: Double? = null,
    val daysWithData: Int = 0,
    val readings: List<DailyEnergyReadingDTO> = emptyList(),
    val metrics: List<BuildingMetricDTO> = emptyList()
)
